import React, { useState } from "react";
import JoditEditor from "../../common/JoditEditor";
import ReusableTable from "../../common/ReusableComponent/reusableTable/ReusableTable";
import { CustomButton } from "../../common/ReusableComponent/CustomButton";

const Policies = () => {
  const [policyContent, setPolicyContent] = useState("");
  const [showEditor, setShowEditor] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCreatePolicy = () => {
    setPolicyContent("");
    setShowEditor(true);
  };

  const fetchPolicyData = async ({ page = 1, searchTerm = "" } = {}) => {
    const mockData = [
      { id: 1, name: "Privacy Policy", created_date: "2024-01-12" },
      { id: 2, name: "Terms & Conditions", created_date: "2024-01-08" }
    ];

    return { data: mockData, totalPages: 1 };
  };

  const handleOnDelete = (id) => {
    console.log("Delete policy:", id);
  };

  const handleOnUpdate = (id) => {
    console.log("Edit policy:", id);
    setShowEditor(true);
  };

  const columns = [
    { header: "Policy Name", field: "name" },
    { header: "Created Date", field: "created_date" }
  ];

  if (showEditor) {
    return (
      <div className="responsive-box">
        <div className="header-row">
          <div className="setting-title">Policy Editor</div>

          <CustomButton
            text="Back to Policies"
            onClick={() => setShowEditor(false)}
            color="#000000"
            backgroundColor="#6c757d"
          />
        </div>

        <div style={{ marginTop: "20px" }}>
          <JoditEditor
            value={policyContent}
            onChange={setPolicyContent}
            placeholder="Write your legal policy here..."
            height="500px"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="responsive-box">
      <div className="header-row">
        <div className="setting-title">Legal Policies</div>

        <CustomButton
          text="Create Policy"
          onClick={handleCreatePolicy}
          color="#000000"
          backgroundColor="#FFAF32"
        />
      </div>

      <ReusableTable
        fetchData={fetchPolicyData}
        columns={columns}
        showAction={true}
        showFooter={true}
        onDelete={handleOnDelete}
        onUpdate={handleOnUpdate}
        loading={loading}
        showEdit={true}
      />
    </div>
  );
};

export default Policies;
